import html2canvas from 'html2canvas';

export async function captureScreen() {
  const clone = document.body.cloneNode(true) as HTMLElement;

  const toHide = clone.querySelector('#floating_button') as HTMLDivElement | null;
  if (toHide) {
    toHide.style.display = 'none';
  }

  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '0';
  container.style.left = '0';
  container.style.width = '100vw';
  container.style.height = '100vh';
  container.style.overflow = 'hidden';
  container.style.zIndex = '-9999'; // 화면 뒤로 보내기
  container.appendChild(clone);
  document.body.appendChild(container);

  const canvas = await html2canvas(clone, {
    useCORS: true,
    scale: window.devicePixelRatio,
  });

  document.body.removeChild(container);

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(blob => {
      if (blob) resolve(blob);
      else reject(new Error('Blob 생성 실패'));
    }, 'image/png');
  });
}
